import { logger } from 'module/logger';
import axios from 'axios';
import { API_HOST, API_NAMESPACE, API_VERSION } from 'config/environment';
import { getOkta } from '../okta/config';
import { TokenType } from '../types';
import { getDecodedValue } from '../utils/decode-token';

const tokenKey = 'rl-token';
const clientIdKey = 'X-Client-ID';
const exists = () => localStorage.getItem('authStatus') === 'true';
const create = async (
  token: string,
  tokenType: TokenType,
  clientId: string,
  externalRefKey?: string,
  projectId?: string,
): Promise<void> => {
  logger.debug('fetching for access token');

  const tokenPayload = getDecodedValue(token);
  const getParams = () => {
    if (tokenType === TokenType.Rocketlane) {
      return { token };
    } else if (tokenType === TokenType.External) {
      return {
        [tokenKey]: token,
      };
    }
  };

  const response = await axios.post<any>(
    tokenType === TokenType.External
      ? '/users/invite-create-api-key'
      : '/users/create-api-key',
    tokenType === TokenType.External
      ? {
          externalRefKey: externalRefKey ?? undefined,
          projectId: projectId ?? undefined,
          user: {
            emailId: tokenPayload?.emailId,
          },
        }
      : null,
    {
      baseURL: `${API_HOST}/${API_NAMESPACE}/${API_VERSION}`,
      headers:
        tokenType === TokenType.Okta || tokenType === TokenType.Cognito
          ? { Authorization: `Bearer ${token}`, [clientIdKey]: clientId }
          : undefined,
      params: getParams(),
      // withCredentials: true,
    },
  );

  if (response.status === 200) {
    localStorage.setItem('authStatus', 'true');
    const api_key = [
      'api_key',
      response.data.apiKey,
      response.data?.createdBy?.userId,
      response.data.apiKeyId,
    ];

    localStorage.setItem('__api_key', JSON.stringify(api_key));
    getOkta()?.tokenManager.clear();
  }
};

const clear = async () => {
  localStorage.setItem('authStatus', 'false');
  localStorage.removeItem('__api_key');
  try {
    await axios.delete('users/delete-api-key', {
      baseURL: `${API_HOST}/${API_NAMESPACE}/${API_VERSION}`,
      withCredentials: true,
    });
    logger.debug('deleted token');
  } catch (error) {
    logger.error('could not delete token', { error });
  }
};

export const TokenAuthentication = {
  exists,
  create,
  clear,
};
